export enum MfaModal {
    configure = 'configure-mfa',
    reset = 'reset-mfa',
    moreInformation = 'configure-mfa-more-information',
    verificationCode = 'configure-mfa-verification-code',
}
